import { twMerge } from "tailwind-merge";

function flattenClassInput(input, output) {
  if (input == null || input === false) return;

  if (typeof input === "string" || typeof input === "number") {
    output.push(String(input));
    return;
  }

  if (Array.isArray(input)) {
    for (const item of input) {
      flattenClassInput(item, output);
    }
    return;
  }

  if (typeof input === "object") {
    for (const [className, condition] of Object.entries(input)) {
      if (condition) output.push(className);
    }
  }
}

export function cn(...inputs) {
  const classes = [];
  for (const input of inputs) {
    flattenClassInput(input, classes);
  }
  return twMerge(classes.join(" "));
}
